// This file is automatically generated. Do not edit it directly.
import type { Database } from '@nfp-tracker/utils';
import { createClient } from '@supabase/supabase-js';
import { resilientAuthStorage } from './authStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "../integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: resilientAuthStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});